import { render } from "./ApiManagement.vue?vue&type=template&id=2ba4360e&scoped=true&lang=pug"
import script from "./ApiManagement.vue?vue&type=script&lang=js"
export * from "./ApiManagement.vue?vue&type=script&lang=js"

import "./ApiManagement.vue?vue&type=style&index=0&id=2ba4360e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba4360e"]])

export default __exports__